import { Reveal } from "@/components/site/Reveal";
import { Download, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function DownloadFollowUpSystem() {
  return (
    <div data-testid="download-page" className="pt-24 min-h-screen bg-[#F5F1EA]">
      <section className="max-w-[900px] mx-auto px-6 lg:px-12 py-20 lg:py-32 text-center">
        <Reveal>
          <p className="overline text-[#B7926A] mb-6">Purchase complete</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#47394E] tracking-tight leading-none">
            The Inquiry Follow-Up System is yours.
          </h1>
          <p className="font-body text-[#47394E]/75 mt-8 max-w-xl mx-auto">
            Thank you for your purchase. Your templates, timing, and tracker are ready —
            download them now and keep them somewhere handy. Stripe has emailed your receipt.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-col items-center gap-4">
            <a
              href="/inquiry-follow-up-system.pdf"
              download
              data-testid="download-product-button"
              className="inline-flex items-center gap-3 rounded-full bg-[#47394E] text-[#E8DCCF] px-10 py-4 font-medium hover:bg-[#B7926A] transition-colors"
            >
              <Download size={18} />
              Download the system
            </a>
            <p className="font-body text-sm text-[#47394E]/50">
              Tip: save the file to your computer — this page is your personal download link.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-20 border-t border-[#47394E]/15 pt-12">
            <p className="overline text-[#A8B39B] mb-4">What's next</p>
            <p className="font-body text-[#47394E]/75 max-w-lg mx-auto">
              Want help putting this into practice? Coaching turns these templates into bookings.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/coaching"
                data-testid="download-next-coaching"
                className="inline-flex items-center gap-2 rounded-full border border-[#47394E]/30 text-[#47394E] px-8 py-3 font-medium hover:bg-[#47394E] hover:text-[#E8DCCF] transition-colors"
              >
                Explore coaching <ArrowRight size={16} />
              </Link>
              <Link
                to="/community"
                data-testid="download-next-community"
                className="inline-flex items-center gap-2 font-body text-[#47394E]/70 hover:text-[#B7926A] transition-colors px-4 py-3"
              >
                Visit the community
              </Link>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
